import { getFilterMetadata } from '../../../components/StatelessComponent/FilterChainUtils';
import { readableRadioTextOperations } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { RadioTextFilterValueType } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';

export function getLabels(currentValue?: RadioTextFilterValueType): LabelProps {
  const metadata = getFilterMetadata(FilterKindEnum.UserID);
  return {
    label1: metadata.filterName,
    label2:
      currentValue && 'value' in currentValue
        ? `${readableRadioTextOperations[currentValue.operation]} "${currentValue.value}"`
        : '',
  };
}
